import React, { forwardRef } from 'react';
import { styled } from '@compiled/react';
import isNil from 'lodash/isNil';
import Textfield from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';
// this could be removed if we move compal controllers to commons package
import { COMPAL_MENU_ID, SEARCH_INPUT_TEST_ID } from '../constants.tsx';

type SearchInputProps = React.ComponentProps<typeof TextFieldStyle> & {
	activeId?: string;
};

export const CommandPaletteSearchInput: React.FC<SearchInputProps> = forwardRef(
	({ activeId, ...rest }, ref) => {
		const ariaProps: React.ComponentProps<typeof TextFieldStyle> = !isNil(activeId)
			? {
					'aria-expanded': true,
					'aria-controls': COMPAL_MENU_ID,
					role: 'combobox',
				}
			: {
					role: 'searchbox',
				};
		return (
			<TextFieldStyle
				appearance="none"
				testId={SEARCH_INPUT_TEST_ID}
				ref={ref}
				{...ariaProps}
				{...rest}
			/>
		);
	},
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextFieldStyle = styled(Textfield)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
		backgroundColor: 'transparent !important',
	},

	color: token('color.text'),
	border: 'none',
	paddingTop: token('space.075'),
	paddingRight: token('space.050'),
	paddingBottom: token('space.075'),
	paddingLeft: token('space.050'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'input,input:not([data-compact])': {
		font: token('font.body.large'),
		paddingTop: '0px',
		paddingBottom: '0px',
		paddingLeft: `${token('space.050')}`,
		height: '20px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'input::placeholder': {
		color: token('color.text.subtlest'),
	},
});
